export const BANNER_DISPLAY_INTERVAL_ONCE = 1 // 1回のみ
export const BANNER_DISPLAY_INTERVAL_DAILY = 2 // 1日に1回
export const BANNER_DISPLAY_INTERVAL_EVERY_3_DAYS = 3 // 3日に1回
export const BANNER_DISPLAY_INTERVAL_WEEKLY = 4 // 7日に1回

export const DISPLAY_LOCATION_ADMIN_POST_LOGIN_MODAL = 201 // Admin ログイン後（モーダル）
export const DISPLAY_LOCATION_ADMIN_POST_LOGIN_MODELESS = 202 // Admin ログイン後（モーダレス）

export type BannerDisplayLocation =
  | typeof DISPLAY_LOCATION_ADMIN_POST_LOGIN_MODAL
  | typeof DISPLAY_LOCATION_ADMIN_POST_LOGIN_MODELESS
